"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verification = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var Verification = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Verification, _super);
    function Verification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验银行卡号验证接口';
        _this.code = '100001';
        _this.desc = '校验银行卡号验证接口';
        _this.requestParams = new bankCard_1.VerificationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Verification;
}(service_1.BaseService));
exports.Verification = Verification;
//# sourceMappingURL=verification.js.map